import React, {useCallback} from 'react';
import OtpAuthScreen from '../../../components/common/OtpAuthScreen';
import {useDocumentCollection} from '../context/DocumentCollectionContext';
import {sendCode, verifyCode, fetchPageModel, completeMockAuth, useMocks} from '../api/documentCollectionApi';

const AuthScreen = () => {
  const {token, authMethods, maskedPhone, customerName, setTokenData} = useDocumentCollection();

  const handleSendCode = useCallback((method) => sendCode(token, method), [token]);

  const handleVerifyCode = useCallback((code) => verifyCode(token, code), [token]);

  const handleAuthenticated = useCallback(async () => {
    if (useMocks) {
      completeMockAuth();
    }
    const pageData = await fetchPageModel(token);
    setTokenData(token, pageData);
  }, [token, setTokenData]);

  return (
    <OtpAuthScreen
      authMethods={authMethods}
      maskedPhone={maskedPhone}
      titleId='docCollection.auth.title'
      titleValues={{name: customerName}}
      descriptionId='docCollection.auth.description'
      onSendCode={handleSendCode}
      onVerifyCode={handleVerifyCode}
      onAuthenticated={handleAuthenticated}
    />
  );
};

export default AuthScreen;
